// La Tocada accessory: stage mic + boom stand.
// Silhouette = mic capsule on a curved boom arm + tripod base + cable curl.
// The cable curl trails off-frame — signals "live on stage."

interface MicStandProps {
  /** Primary fill (mic capsule + stand). Defaults to stage hot pink. */
  bodyColor?: string;
  /** Accent fill (cable + base accents). Defaults to candy purple. */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function MicStand({
  bodyColor = '#ff2e7e',
  accentColor = '#6b2d8c',
  size = 48,
  className,
}: MicStandProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Mic capsule — top, slightly tilted toward viewer */}
      <ellipse
        cx="30"
        cy="10"
        rx="6"
        ry="7"
        fill={bodyColor}
        transform="rotate(-15 30 10)"
      />
      {/* Mic grille pattern */}
      <line x1="26" y1="8" x2="34" y2="8" stroke={accentColor} strokeWidth="0.8" />
      <line x1="26" y1="10" x2="34" y2="10" stroke={accentColor} strokeWidth="0.8" />
      <line x1="26" y1="12" x2="34" y2="12" stroke={accentColor} strokeWidth="0.8" />
      {/* Mic body / handle */}
      <rect x="28" y="14" width="4" height="6" rx="1" fill={accentColor} transform="rotate(-15 30 17)" />
      {/* Boom arm — curves down from mic to stand */}
      <path
        d="M30 20 Q24 24 22 32"
        stroke={bodyColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Vertical stand pole */}
      <rect x="20" y="30" width="4" height="12" fill={bodyColor} />
      {/* Tripod base — three legs splayed */}
      <path
        d="M22 42 L10 46 M22 42 L34 46 M22 42 L22 47"
        stroke={bodyColor}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      {/* Base hub */}
      <circle cx="22" cy="42" r="3" fill={accentColor} />
      {/* Cable curl — trailing off bottom-left, signals live connection */}
      <path
        d="M14 44 Q6 44 4 40 Q4 36 8 36"
        stroke={accentColor}
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
        opacity="0.8"
      />
    </svg>
  );
}
